export const styles = theme => ({
  link: {
    color: theme.palette.primary.main,
  },
})
